import * as mutationTypes from "./mutation-types";
export const actions = {
  getUser: async ({ commit }) => {
    let jwt=sessionStorage.getItem('jwt');
    console.log(5,jwt);
    //this.state.user.loading=true;
    try{
        const res = await this.$http.post('/ajax/settings/settings_read.php', {"jwt":jwt});
        if (res.data.errorid=='0')
        { 
          let payload=res.data.settings;
          console.log(12,res.data.settings);
          commit(mutationTypes.SET_SETTINGS, payload);
        }
        else
        {
          this.$router.push('/auth/login').catch(() => {});
          //this.$router.go();
        }      
    } catch(e)
    {
      //this.$router.go();
    }
    //this.state.user.loading=false;    
  },    
}

export default {
  actions,
};